// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `#UnreadChatMessageCount {
  margin-top: 14px !important;
}
#m_quick_sidebar_back i.la-arrow-circle-left {
  color: #cfcedb;
  text-decoration: none;
}
#m_quick_sidebar_back i.la-arrow-circle-left:hover {
  color: #716aca !important;
}
.contact-status1 {
  position: absolute;
  display: inline-block;
  width: 12px;
  height: 12px;
  border-radius: 50% !important;
  left: 52px;
  margin-top: 26px;
}
.contact-status1.online {
  background-color: #26C281;
}
.contact-status1.offline {
  background-color: #BFCAD1;
}
span.contact-status2 {
  position: relative;
  width: 12px;
  height: 12px;
  border-radius: 50% !important;
  left: 0px;
  top: 0px !important;
  display: block;
  margin-left: 30px;
  margin-top: -10px;
}
span.contact-status2.online {
  background-color: #26C281;
}
span.contact-status2.offline {
  background-color: #BFCAD1;
}
.m-quick-sidebar {
  overflow-y: hidden !important;
}
div.selected-chat-user {
  margin: 10px;
  padding-bottom: 5px;
  display: block;
  padding-right: 5px;
}
div.selected-chat-user div.selected-chat-user-image {
  display: inline-block;
}
div.selected-chat-user div.selected-chat-user-image img {
  display: inline-block;
  width: 40px;
}
div.selected-chat-user h6 {
  display: inline-block;
  margin-left: 5px;
}
div.selected-chat-user div.actions {
  display: inline-block;
  float: right;
  padding-top: 5px;
}
div.selected-chat-user div.actions a.btn-sm {
  padding: 6px 26px 6px 10px !important;
  width: 50px;
}
#friendListFriends .m-badge.m-badge--warning {
  color: white !important;
  float: right;
}
.m-messenger__message--out .m-messenger__message-username {
  text-align: right !important;
}
.chat-progress-bar {
  display: none;
}
.chat-image-preview {
  width: 235px;
  margin-top: 5px;
}
.chat-file-preview {
  margin-top: 15px;
  text-align: left;
  padding: 5px;
  background-color: #625dbb;
  display: block;
  color: #d9d9d9;
}
.chat-file-preview i.la-file {
  margin-right: 2px;
}
.chat-file-preview i.la-download {
  margin-top: 2px;
}
.chat-file-preview:hover {
  color: #fff;
}
.chat-file-preview:hover i {
  text-decoration: none;
}
.chat-link-message {
  display: block;
  text-overflow: ellipsis;
  overflow-x: hidden;
  white-space: nowrap;
  margin-top: 15px;
  text-align: left;
  padding: 5px;
  background-color: #3598dc;
  color: #f7f7f7;
}
.chat-progress-bar {
  display: none;
}
.m-messenger-friends .m-list-search__result-category {
  margin-top: 10px !important;
}
.slimScrollBar {
  width: 2px !important;
  background-color: lightgray !important;
}
#m_quick_sidebar_close {
  cursor: pointer;
}
/* Quick Sidebar Pinner */
.m-quick-sidebar--on a.page-quick-sidebar-pinner {
  display: inline-block !important;
}
a.page-quick-sidebar-pinner {
  overflow: hidden;
  z-index: 99999;
  width: 28px;
  height: 27px;
  position: fixed;
  top: 10px;
  right: 50px;
  text-align: center;
  padding-top: 6px;
  display: none;
}
@media (min-width: 767px) {
  a.page-quick-sidebar-pinner {
    right: 15px;
  }
}
a.page-quick-sidebar-pinner {
  opacity: 0.5 !important;
  background-repeat: no-repeat;
  background-position-y: 12px;
}
a.page-quick-sidebar-pinner:hover {
  color: #fff;
}
a.page-quick-sidebar-pinner.unpinned {
  background-image: url("/assets/common/images/unpinned.png");
}
a.page-quick-sidebar-pinner.pinned {
  background-image: url("/assets/common/images/pinned.png");
}
@media (min-width: 767px) {
  .m-quick-sidebar__close {
    display: none;
  }
}
.toast-chat-open {
  right: 460px;
  bottom: 12px;
}
/*Stlye for Chat Buttons */
.m-messenger__form-tools .ui-button {
  display: block;
  margin: 0;
  text-align: left;
  border-radius: 0;
  transition: none !important;
}
.ui-fileupload-choose.ui-button,
.ui-fileupload-choose.ui-button .ui-widget,
.ui-fileupload-choose.ui-button .ui-state-default {
  background-color: #fff;
  color: #6f6f6f;
}
.ui-fileupload-choose.ui-button.ui-state-hover,
.ui-fileupload-choose.ui-button.ui-state-focus,
.ui-fileupload-choose.ui-button.ui-state-active {
  background-color: #eee;
}
.m-messenger__form-tools a:hover .ui-button {
  background-color: #f4f5f8 !important;
}
.m-messenger__form-tools .ui-fileupload-choose:not(.ui-state-disabled):hover,
.m-messenger__form-tools .ui-fileupload-choose:not(.ui-state-disabled):focus,
.m-messenger__form-tools .ui-fileupload-choose:not(.ui-state-disabled):active {
  background-color: #f4f5f8 !important;
  box-shadow: none !important;
}
.m-messenger__form-tools .chat-link-button {
  width: 100%;
  border: none;
}
.m-messenger__form-tools .chat-image-preview {
  width: 235px;
  margin-top: 5px;
}
.m-messenger__form-tools .chat-file-preview {
  margin-top: 15px;
  text-align: left;
  padding: 5px;
  background-color: #f0ad4e;
  display: block;
  color: #f7f7f7;
}
.m-messenger__form-tools .chat-link-message {
  display: block;
  text-overflow: ellipsis;
  overflow-x: hidden;
  white-space: nowrap;
  margin-top: 15px;
  text-align: left;
  padding: 5px;
  background-color: #3598dc;
  color: #f7f7f7;
}
`, "",{"version":3,"sources":["webpack://./src/app/shared/layout/chat/chat-bar.component.less"],"names":[],"mappings":"AAAA;EACI,2BAAA;AACJ;AAEA;EAEQ,cAAA;EACA,qBAAA;AADR;AAGQ;EACI,yBAAA;AADZ;AAMA;EACI,kBAAA;EACA,qBAAA;EACA,WAAA;EACA,YAAA;EACA,6BAAA;EACA,UAAA;EACA,gBAAA;AAJJ;AAMI;EACI,yBAAA;AAJR;AAOI;EACI,yBAAA;AALR;AASA;EACI,kBAAA;EACA,WAAA;EACA,YAAA;EACA,6BAAA;EACA,SAAA;EACA,mBAAA;EACA,cAAA;EACA,iBAAA;EACA,iBAAA;AAPJ;AASI;EACI,yBAAA;AAPR;AAUI;EACI,yBAAA;AARR;AAYA;EACI,6BAAA;AAVJ;AAaA;EACI,YAAA;EACA,mBAAA;EACA,cAAA;EACA,kBAAA;AAXJ;AAOA;EAOQ,qBAAA;AAXR;AAIA;EAUY,qBAAA;EACA,WAAA;AAXZ;AAAA;EAgBQ,qBAAA;EACA,gBAAA;AAbR;AAJA;EAqBQ,qBAAA;EACA,YAAA;EACA,gBAAA;AAdR;AATA;EA0BY,qCAAA;EACA,WAAA;AAdZ;AAmBA;EAEQ,uBAAA;EACA,YAAA;AAlBR;AAsBA;EAEQ,4BAAA;AArBR;AAyBA;EACI,aAAA;AAvBJ;AA0BA;EACI,YAAA;EACA,eAAA;AAxBJ;AA2BA;EACI,gBAAA;EACA,gBAAA;EACA,YAAA;EACA,yBAAA;EACA,cAAA;EACA,cAAA;AAzBJ;AAmBA;EASQ,iBAAA;AAzBR;AAgBA;EAaQ,eAAA;AA1BR;AA6BI;EACI,WAAA;AA3BR;AA0BI;EAIQ,qBAAA;AA3BZ;AAgCA;EACI,cAAA;EACA,uBAAA;EACA,kBAAA;EACA,mBAAA;EACA,gBAAA;EACA,gBAAA;EACA,YAAA;EACA,yBAAA;EACA,cAAA;AA9BJ;AAiCA;EACI,aAAA;AA/BJ;AAkCA;EAEQ,2BAAA;AAjCR;AAqCA;EACI,qBAAA;EACA,sCAAA;AAnCJ;AAsCA;EACI,eAAA;AApCJ;AACA,yBAAyB;AAuCzB;EACI,gCAAA;AArCJ;AAwCA;EACI,gBAAA;EACA,cAAA;EACA,WAAA;EACA,YAAA;EACA,eAAA;EACA,SAAA;EACA,WAAA;EACA,kBAAA;EACA,gBAAA;EACA,aAAA;AAtCJ;AAyCA;EACI;IACI,WAAA;EAvCN;AACF;AA0CA;EACI,uBAAA;EACA,4BAAA;EACA,2BAAA;AAxCJ;AA2CA;EACI,WAAA;AAzCJ;AA4CA;EACI,2DAAA;AA1CJ;AA6CA;EACI,yDAAA;AA3CJ;AA+CI;EAAA;IACI,aAAA;EA5CN;AACF;AA+CA;EACI,YAAA;EACA,YAAA;AA7CJ;AACA,0BAA0B;AAgD1B;EACI,cAAA;EACA,SAAA;EACA,gBAAA;EACA,gBAAA;EACA,2BAAA;AA9CJ;AAiDA;;;EACI,sBAAA;EACA,cAAA;AA7CJ;AAgDA;;;EACI,sBAAA;AA5CJ;AA+CA;EAGY,oCAAA;AA/CZ;AAmDA;;;EAGI,oCAAA;EACA,2BAAA;AAjDJ;AAoDA;EACI,WAAA;EACA,YAAA;AAlDJ;AAwDA;EACI,YAAA;EACA,eAAA;AAtDJ;AAyDA;EACI,gBAAA;EACA,gBAAA;EACA,YAAA;EACA,yBAAA;EACA,cAAA;EACA,cAAA;AAvDJ;AA0DA;EACI,cAAA;EACA,uBAAA;EACA,kBAAA;EACA,mBAAA;EACA,gBAAA;EACA,gBAAA;EACA,YAAA;EACA,yBAAA;EACA,cAAA;AAxDJ","sourcesContent":["#UnreadChatMessageCount {\n    margin-top: 14px !important;\n}\n\n#m_quick_sidebar_back {\n    i.la-arrow-circle-left {\n        color: #cfcedb;\n        text-decoration: none;\n\n        &:hover {\n            color: #716aca !important;\n        }\n    }\n}\n\n.contact-status1 {\n    position: absolute;\n    display: inline-block;\n    width: 12px;\n    height: 12px;\n    border-radius: 50% !important;\n    left: 52px;\n    margin-top: 26px;\n\n    &.online {\n        background-color: #26C281;\n    }\n\n    &.offline {\n        background-color: #BFCAD1;\n    }\n}\n\nspan.contact-status2 {\n    position: relative;\n    width: 12px;\n    height: 12px;\n    border-radius: 50% !important;\n    left: 0px;\n    top: 0px !important;\n    display: block;\n    margin-left: 30px;\n    margin-top: -10px;\n\n    &.online {\n        background-color: #26C281;\n    }\n\n    &.offline {\n        background-color: #BFCAD1;\n    }\n}\n\n.m-quick-sidebar {\n    overflow-y: hidden !important;\n}\n\ndiv.selected-chat-user {\n    margin: 10px;\n    padding-bottom: 5px;\n    display: block;\n    padding-right: 5px;\n\n    div.selected-chat-user-image {\n        display: inline-block;\n\n        img {\n            display: inline-block;\n            width: 40px;\n        }\n    }\n\n    h6 {\n        display: inline-block;\n        margin-left: 5px;\n    }\n\n    div.actions {\n        display: inline-block;\n        float: right;\n        padding-top: 5px;\n\n        a.btn-sm {\n            padding: 6px 26px 6px 10px !important;\n            width: 50px;\n        }\n    }\n}\n\n#friendListFriends {\n    .m-badge.m-badge--warning {\n        color: white !important;\n        float: right;\n    }\n}\n\n.m-messenger__message--out {\n    .m-messenger__message-username {\n        text-align: right !important;\n    }\n}\n\n.chat-progress-bar {\n    display: none;\n}\n\n.chat-image-preview {\n    width: 235px;\n    margin-top: 5px;\n}\n\n.chat-file-preview {\n    margin-top: 15px;\n    text-align: left;\n    padding: 5px;\n    background-color: #625dbb;\n    display: block;\n    color: #d9d9d9;\n\n    i.la-file {\n        margin-right: 2px;\n    }\n\n    i.la-download {\n        margin-top: 2px;\n    }\n\n    &:hover {\n        color: #fff;\n\n        i {\n            text-decoration: none;\n        }\n    }\n}\n\n.chat-link-message {\n    display: block;\n    text-overflow: ellipsis;\n    overflow-x: hidden;\n    white-space: nowrap;\n    margin-top: 15px;\n    text-align: left;\n    padding: 5px;\n    background-color: #3598dc;\n    color: #f7f7f7;\n}\n\n.chat-progress-bar {\n    display: none;\n}\n\n.m-messenger-friends {\n    .m-list-search__result-category {\n        margin-top: 10px !important;\n    }\n}\n\n.slimScrollBar {\n    width: 2px !important;\n    background-color: lightgray !important;\n}\n\n#m_quick_sidebar_close {\n    cursor: pointer;\n}\n\n/* Quick Sidebar Pinner */\n.m-quick-sidebar--on a.page-quick-sidebar-pinner {\n    display: inline-block !important;\n}\n\na.page-quick-sidebar-pinner {\n    overflow: hidden;\n    z-index: 99999;\n    width: 28px;\n    height: 27px;\n    position: fixed;\n    top: 10px;\n    right: 50px;\n    text-align: center;\n    padding-top: 6px;\n    display: none;\n}\n\n@media (min-width: 767px) {\n    a.page-quick-sidebar-pinner {\n        right: 15px;\n    }\n}\n\na.page-quick-sidebar-pinner {\n    opacity: 0.5 !important;\n    background-repeat: no-repeat;\n    background-position-y: 12px;\n}\n\na.page-quick-sidebar-pinner:hover {\n    color: #fff;\n}\n\na.page-quick-sidebar-pinner.unpinned {\n    background-image: url(\"/assets/common/images/unpinned.png\");\n}\n\na.page-quick-sidebar-pinner.pinned {\n    background-image: url(\"/assets/common/images/pinned.png\");\n}\n\n.m-quick-sidebar__close {\n    @media (min-width: 767px) {\n        display: none;\n    }\n}\n\n.toast-chat-open {\n    right: 460px;\n    bottom: 12px;\n}\n\n/*Stlye for Chat Buttons */\n.m-messenger__form-tools .ui-button {\n    display: block;\n    margin: 0;\n    text-align: left;\n    border-radius: 0;\n    transition: none !important;\n}\n\n.ui-fileupload-choose.ui-button, .ui-fileupload-choose.ui-button .ui-widget, .ui-fileupload-choose.ui-button .ui-state-default {\n    background-color: #fff;\n    color: #6f6f6f;\n}\n\n.ui-fileupload-choose.ui-button.ui-state-hover, .ui-fileupload-choose.ui-button.ui-state-focus, .ui-fileupload-choose.ui-button.ui-state-active {\n    background-color: #eee;\n}\n\n.m-messenger__form-tools {\n    a:hover {\n        .ui-button {\n            background-color: #f4f5f8 !important;\n        }\n    }\n}\n.m-messenger__form-tools .ui-fileupload-choose:not(.ui-state-disabled):hover,\n.m-messenger__form-tools .ui-fileupload-choose:not(.ui-state-disabled):focus,\n.m-messenger__form-tools .ui-fileupload-choose:not(.ui-state-disabled):active {\n    background-color: #f4f5f8 !important;\n    box-shadow: none !important;\n}\n\n.m-messenger__form-tools .chat-link-button {\n    width: 100%;\n    border: none;\n}\n\n.m-messenger__form-tools .ui-button span {\n}\n\n.m-messenger__form-tools .chat-image-preview {\n    width: 235px;\n    margin-top: 5px;\n}\n\n.m-messenger__form-tools .chat-file-preview {\n    margin-top: 15px;\n    text-align: left;\n    padding: 5px;\n    background-color: #f0ad4e;\n    display: block;\n    color: #f7f7f7;\n}\n\n.m-messenger__form-tools .chat-link-message {\n    display: block;\n    text-overflow: ellipsis;\n    overflow-x: hidden;\n    white-space: nowrap;\n    margin-top: 15px;\n    text-align: left;\n    padding: 5px;\n    background-color: #3598dc;\n    color: #f7f7f7;\n}\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
